export default __webpack_public_path__ + "static/media/star.ce1077fe.svg";